"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoritesManager = void 0;
var tslib_1 = require("tslib");
var firestoreMyList_1 = require("./firestoreMyList");
var FavoritesManager = /** @class */ (function () {
    function FavoritesManager() {
        this.myListManager = new firestoreMyList_1.FirestoreMyListManager();
    }
    FavoritesManager.prototype.add = function (userId, item, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.myListManager.add(userId, item, profileId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FavoritesManager.prototype.remove = function (userId, itemId, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.myListManager.remove(userId, itemId, profileId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FavoritesManager.prototype.getItem = function (userId, itemId, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.myListManager.getItem(userId, itemId, profileId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FavoritesManager.prototype.getItems = function (userId, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.myListManager.getItems(userId, profileId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return FavoritesManager;
}());
exports.FavoritesManager = FavoritesManager;
